/**
 * 측정값 유틸리티 함수
 * µT 단위 표시 및 등급 관련 헬퍼 함수
 */

/**
 * nT를 µT로 변환
 * @param {number} valueNT - 나노테슬라 값
 * @returns {number} 마이크로테슬라 값
 */
export function nTToUT(valueNT) {
  if (!valueNT || isNaN(valueNT)) return 0;
  return parseFloat(valueNT) / 1000;
}

/**
 * µT 값을 UX 표시 형식으로 변환 (120 µT 초과 시 "120+" 표시)
 * @param {number} valueUT - 마이크로테슬라 값
 * @param {number} maxUT - UX 표시 상한 (기본값: 120)
 * @returns {string} 표시 형식 문자열
 */
export function formatMeasurementDisplay(valueUT, maxUT = 120) {
  if (!valueUT || isNaN(valueUT)) return '0.00';
  
  const value = parseFloat(valueUT);
  
  if (value > maxUT) {
    return `${maxUT}+`;
  }
  
  return value.toFixed(2);
}

/**
 * 측정값을 µT 단위로 포맷팅
 * @param {number} value - 측정값 (nT 또는 µT)
 * @param {boolean} isNT - nT 단위인지 여부 (기본값: false)
 * @param {number} maxUT - UX 표시 상한 (기본값: 120)
 * @returns {string} 포맷된 문자열 (예: "45.23 µT" 또는 "120+ µT")
 */
export function formatMeasurement(value, isNT = false, maxUT = 120) {
  if (!value || isNaN(value)) return '0.00 µT';
  
  const valueUT = isNT ? nTToUT(value) : parseFloat(value);
  const displayValue = formatMeasurementDisplay(valueUT, maxUT);
  
  return `${displayValue} µT`;
}

/**
 * 등급에 따른 배지 색상 클래스 반환
 * @param {string} grade - 등급 코드 (weak, medium, strong, very_strong, extreme)
 * @returns {string} Tailwind CSS 클래스
 */
export function getGradeBadgeClass(grade) {
  switch (grade) {
    case 'weak':
      return 'bg-gradient-to-r from-blue-500 to-blue-600 text-white';
    case 'medium':
      return 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white';
    case 'strong':
      return 'bg-gradient-to-r from-orange-500 to-orange-600 text-white';
    case 'very_strong':
      return 'bg-gradient-to-r from-red-500 to-red-600 text-white';
    case 'extreme':
      return 'bg-gradient-to-r from-purple-500 to-purple-600 text-white';
    default:
      return 'bg-gradient-to-r from-gray-500 to-gray-600 text-white';
  }
}

/**
 * 등급 표시명 반환
 * @param {string} grade - 등급 코드
 * @param {string} gradeDisplay - 등급 표시명 (있는 경우)
 * @returns {string} 등급 표시명
 */
export function getGradeDisplay(grade, gradeDisplay) {
  if (gradeDisplay) return gradeDisplay;
  
  switch (grade) {
    case 'weak':
      return '약함';
    case 'medium':
      return '중간';
    case 'strong':
      return '강함';
    case 'very_strong':
      return '매우 강함';
    case 'extreme':
      return '극강';
    default:
      return '분류되지 않음';
  }
}
